import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import LoadingTable from "../LoadingTable";
import { formatDateTime } from "../../helpers/utils";

import { getP24ImplementationTypeById } from "../../constants/P24ImplementationType";


/**
 * 
 * Tabelka z logami
 *
 */
class P24LogTable extends React.Component {

    /**
      * Globalna metoda tłumacząca
      * 
      * @param {String} key klucz to tłumaczeń 
      * @param {Object} params obiekt z parametrami do tłumaczenia
      */
    formatMessage = (key, params) => {
        return this.props.intl.formatMessage({ id: key }, params);
    };


    /**
      * Kolumny do tabelki
      */
    tableColumns = [
        {
            Header: this.formatMessage("p24Log.id"),
            accessor: "id",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24Log.restaurantId"),
            accessor: "restaurantId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24Log.p24MerchantId"),
            accessor: "p24MerchantId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 70
        },
        {
            Header: this.formatMessage("p24Log.implType"),
            id: "implType",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 100,
            accessor: data => getP24ImplementationTypeById(data.implType).displayText
        },
        {
            Header: this.formatMessage("p24Log.serviceType"),
            accessor: "serviceType",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 150
        },
        {
            Header: this.formatMessage("p24Log.method"),
            accessor: "method",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' },
            maxWidth: 80
        },
        {
            Header: this.formatMessage("p24Log.uri"),
            accessor: "uri",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24Log.requestHeader"),
            accessor: "requestHeader",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24Log.requestBody"),
            accessor: "requestBody",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24Log.responseStatus"),
            accessor: "responseStatus",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            maxWidth: 50
        },
        {
            Header: this.formatMessage("p24Log.responseHeader"),
            accessor: "responseHeader",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24Log.responseBody"),
            accessor: "responseBody",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", overflowWrap: 'break-word' }
        },
        {
            Header: this.formatMessage("p24Log.sessionId"),
            accessor: "sessionId",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 100
        },
        {
            Header: this.formatMessage("p24Log.creationDate"),
            id: "creationDate",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset" },
            maxWidth: 180,
            accessor: data => {
                return formatDateTime(data.creationDate);
            }
        },
    ];


    render() {
        return (
            <div>

                <LoadingTable
                    data={this.props.logs}
                    columns={this.tableColumns}
                    loading={false}
                />

            </div>
        )
    }
}

P24LogTable.propTypes = {
    //lista logów do tabelki
    logs: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
   // p24RestaurantLogList: state.p24RestaurantLogReducer.p24RestaurantLogList,
});

const mapDispatchToProps = ({

});

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
);

export default compose(
    withConnect,
    injectIntl
)(P24LogTable);